"use strict";
/**
 * Created by wangtong on 2021/3/16
 * 快捷键
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShortCut = void 0;
var ShortCut;
(function (ShortCut) {
    // 检查快捷键是否被触发
    function check(event, key) {
        return key.key == event.key && !!key.ctrl == event.ctrlKey && !!key.command == event.metaKey && !!key.shift == event.shiftKey && !!key.alt == event.altKey;
    }
    ShortCut.check = check;
    // url限定
    function addListener(key, callback, url) {
        var listener = function (event) {
            if (check(event, key)) {
                if (url && window.location.href !== url) {
                    return;
                }
                event.preventDefault();
                callback();
            }
        };
        document.addEventListener("keydown", listener);
        return listener;
    }
    ShortCut.addListener = addListener;
    function removeListener(listener) {
        if (listener) {
            document.removeEventListener("keydown", listener);
        }
    }
    ShortCut.removeListener = removeListener;
})(ShortCut || (ShortCut = {}));
exports.ShortCut = ShortCut;
//# sourceMappingURL=shortcut.js.map